import { Component } from '@angular/core';

@Component({
  selector: 'app-validation-beta',
  standalone: true,
  imports: [],
  templateUrl: './validation-beta.component.html',
  styleUrl: './validation-beta.component.css'
})
export class ValidationBetaComponent {

}
